import React from 'react';
import { useTranslation } from "react-i18next";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"

const SupplierTable = ({suppliersData}) => {
    console.log(suppliersData)
    const { t } = useTranslation();
    //const ItemTagsData=[]
  return (
    <Box
    bg="light" overflow="auto"
    borderRadius={4} boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
  >
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>{t("pages.branches.name")}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {suppliersData.map((el, index) => (
          <Tr key={el.ItemsSuppliersId}>
            <Td>{index + 1}</Td>
            <Td>{el?.Suppliers[0].SuppliersName}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
  );
}

export default SupplierTable;
